﻿import {SearchSupplierSortType} from "../../types/supplier/SearchSupplierSortType";
import {useEffect, useState} from "react";
import type {Supplier} from "../../types/Supplier";
import {useSupplierSortByDistance} from "../supplier/useSupplierSortByDistance";
import {useSupplierSortByMonthlyRateLow} from "../supplier/useSupplierSortByMonthlyRateLow";
import {useSupplierSortByMonthlyRateHigh} from "../supplier/useSupplierSortByMonthlyRateHigh";
import {useSupplierSortByDailyRateLow} from "../supplier/useSupplierSortByDailyRateLow";
import {useSupplierSortByDailyRateHigh} from "../supplier/useSupplierSortByDailyRateHigh";

interface SearchSupplierSortByTypes {
  searchSortBy: SearchSupplierSortType
  unsortedSuppliers: Array<Supplier>
}

// Hooks specific to the search screens sorting capabilities
export const useSearchSupplierSortBy = ({searchSortBy, unsortedSuppliers}: SearchSupplierSortByTypes) => {
  const [sortedSuppliers, setSortedSuppliers] = useState<Supplier[]>(unsortedSuppliers);

  useSupplierSortByDistance({searchSortBy, unsortedSuppliers, sortedSuppliersSetter: setSortedSuppliers});

  useSupplierSortByMonthlyRateLow({searchSortBy, unsortedSuppliers, sortedSuppliersSetter: setSortedSuppliers});
  useSupplierSortByMonthlyRateHigh({searchSortBy, unsortedSuppliers, sortedSuppliersSetter: setSortedSuppliers});

  useSupplierSortByDailyRateLow({searchSortBy, unsortedSuppliers, sortedSuppliersSetter: setSortedSuppliers});
  useSupplierSortByDailyRateHigh({searchSortBy, unsortedSuppliers, sortedSuppliersSetter: setSortedSuppliers});

  useEffect(() => {
    if (unsortedSuppliers.length === 0) {
      setSortedSuppliers([]);
    }
  }, [unsortedSuppliers.length]);

  return {
    sortedSuppliers
  }
}
